<template lang="pug">
  div
    section.content-header
      h1 お知らせ
      ol.breadcrumb
        li
          router-link(:to="{name: 'top'}")
            span.glyphicon.glyphicon-home
            | TOP
        li.active お知らせ

    section.content
      app-messages(:errorMessages="errors", :successMessages="successes")

      mixin btnbar
        .bcard-btnbar.clearfix(class!=attributes.class)
          .pull-left
            router-link.btn.btn-default(:to="{name: 'top'}", title="戻る"): i.fa.fa-reply
            |
            |
            .btn-separator
            |
            |
            button.btn.btn-danger(type="button" @click.prevent="modalState = true") 削除
          .pull-right
            app-pagination(:is-loading="loadingPagination", :pagination="pagination", @change="getList")

      +btnbar

      // 一覧
      .row
        .col-sm-12
          .panel.panel-default

            loading(v-if="loading")

            .table-responsive(v-else-if="list.length > 0")
              table.table.table-striped.table-bordered.bcard-table
                thead
                  tr
                    th.bcard-table-td-chk
                      input(type="checkbox" @change="checkAll(list, $event.target.checked)")
                    th 概要
                    th.bcard-table-td-ymdhi
                      i.fa.fa-sort-desc.bcard-table-sort-header-icon
                      | 日時
                tbody
                  tr(v-for="item in list", :key="item.id", :class="{'selected': isChecked(item.id)}")
                    td.bcard-table-td-chk
                      input(type="checkbox", :checked="isChecked(item.id)", @change="checkItem(item.id, $event.target.checked)")
                    td.bcard-ui-userdata(:class="{'unread': item.unread === app_flag.ON}")
                      router-link(:to="{name: 'information-detail', params: {id: '' + item.id, item: item}}", :title="item.message")
                        info-icon(:functionCode="item.function", :infoType="item.type" showMode="list")
                        | &nbsp;
                        | {{item.message}}
                    td.bcard-table-td-ymdhi {{item.updated}}

            //- データなし
            .panel-body.text-center(v-else) お知らせはありません。

      +btnbar

      ul.bcard-legend
        li(v-for="(item, index) in legendIcons", :key="index")
          info-icon(:infoType="item.type" showMode="list")
          | ：{{item.text}}

    //- お知らせの削除
    app-modal(v-model="modalState" :type="hasCheckedItems() ? 'danger' : 'info'")
      template(slot="title") お知らせの削除
      template(v-if="hasCheckedItems()")
        h4 選択したお知らせを削除します。よろしいですか？
      h4(v-else) 削除する対象を選択してください
      template(slot="footer" slot-scope="{close}")
        button.btn.btn-danger(v-if="hasCheckedItems()" @click.prevent="close(); delData();") 削除
        button.btn.btn-default(@click.prevent="close") キャンセル

</template>

<script>
import mixinList from '@/mixins/list'
import AppModal from '@/components/templates/AppModal'
import AppMessages from '@/components/molecules/AppMessages'
import InfoIcon from '@/components/molecules/InfoIcon'
import AppPagination from '@/components/molecules/AppPagination'
import Loading from '@/components/molecules/Loading'

export default {
  name: 'InformationList',
  components: { AppPagination, AppModal, AppMessages, InfoIcon, Loading },
  mixins: [ mixinList ],
  data: function () {
    return {
      loadingPagination: true,
      loading: true,
      legendIcons: [
        {'type': 'I', 'text': 'イベント'},
        {'type': 'T', 'text': '作業依頼'},
        {'type': 'E', 'text': 'エラー'}
      ],
      modalState: false
    }
  },
  created: function () {
    // 初期データ取得
    this.getList({page: this.pagination.current_page || 1})
  },
  methods: {
    /**
     * 一覧取得処理
     * @param Object options
     *          page: ページ番号
     */
    getList: function (options) {
      const vm = this
      this.loading = true
      this.loadingPagination = !options.viaPagination
      // API実行
      this.sendListRequest({
        repo: 'info',
        method: 'getList',
        params: {
          page: options.page || 1
        },
        finally: function () {
          vm.loading = false
          vm.loadingPagination = false
        }
      })
    },
    delData: function () {
      const vm = this

      // API実行
      this.sendBulkRequest('info', 'bulkDelete', {
        params: {
          id: this.checkedIds
        },
        onSuccess: function (response) {
          vm.$store.dispatch('reloadHeaderInfo')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
//@charset 'utf-8';
// 未読
.unread {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/information/List.vue